import React, { useCallback, useEffect, useRef, useState } from "react";
import "./updateTranslation.css";
import {
  Autocomplete,
  CircularProgress,
  MenuItem,
  Tooltip,
} from "@mui/material";
import * as updateTranslationType from "./updateTranslationType";
import { Box, Modal } from "@mui/material";
import TextField from "@mui/material/TextField";
import { Loader } from "../../components/loader/Loader";
import {
  DataGrid,
  GridColDef,
  GridColumnHeaderParams,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import RenderSvg from "../renderSvg/RenderSvg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { ChannelkartNetworkPut } from "../../services/networkService";
import {
  changeKeyToSnakeCase,
  checkReportStatus,
  translationUpload,
} from "../../services/translationService/translationService";
import {
  addTranslationRequestService,
  deleteSingleTranslation,
  getClientConfiguartions,
  getComponetOptions,
  getTranslationForEachLanguage,
} from "../../services/updateTransaltionService";
import ViewAndEditModal from "../viewAndEditModal/ViewAndEditModal";
import {
  batchType,
  dataGridHeaderType,
  languageToDataMapType,
  languageType,
  popUpType,
  translationResponseType,
  updateRequestType,
} from "./updateTranslationType";
import { getReportStatus } from "../../services/supportService";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { ConfirmationPopUp } from "../popup/confirmationPopUp";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

const UpdateTranslation = () => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT = "Update Translation"
  const [result, setResult] = useState<boolean>(false);
  const [component, setComponent] = useState<string>("");
  const [rowData, setRowData] = useState<popUpType[]>();
  const [copyRowData, setCopyRowData] = useState<popUpType[]>();
  const [blobData, setBlobData] = useState(new FormData());
  const [file, setFile] = useState<File | null>(null);
  const [dataGridColumns, setDataGridColumns] = useState<dataGridHeaderType[]>(
    []
  );

  const [languageSupported, setLanguageSupported] = useState<languageType[]>(
    []
  );

  const [openModal, toggleModal] = useState(false);
  const [popUpData, setPopUpData] = useState<popUpType>({});
  const [preFilledData, setPreFilledData] = useState<popUpType>({});
  const [searchedValue, setSeacrhedvalue] = useState("");
  const [timerId, setTimerId] = useState<NodeJS.Timeout | null>(null);
  const [loader, setLoader] = useState(true);

  const [confirmationPopUp, setConfirmationPopUp] = useState(false);

  const [popUpMessage, setPopUpMessage] = useState<string>("");

  const popUpSuccessMethod = useRef<() => void>();

  const [circularLoader, setCircularLoader] = useState(false);

  const [componentOptions, setComponentOptions] = useState([]);

  const [error, setError] = useState(false);

  const updateConfirmationPopData = (
    message: string,
    methodHelper: () => void
  ) => {
    popUpSuccessMethod.current = methodHelper;
    setPopUpMessage(message);
  };

  useEffect(() => {
    getClientConfig();
  }, []);

  const inputE1 = useRef<HTMLInputElement>(null);
  const onUploadBtnClick = () => {
    if (inputE1.current) {
      inputE1.current.click();
    }
  };

  const getClientConfig = async () => {
    try {
      const response = await getClientConfiguartions("multi_lingual_configuration");
      const configurationArray = response.data.features[0];
      const language = configurationArray?.domainValues.find(
        (eachConfig: any) => {
          return eachConfig.name === "supportedLanguages";
        }
      );
      if (language && language.value) {
        const dataGridHeader = [
          { headerName: "Component", mappedValue: "component" },
          { headerName: "Translational Key", mappedValue: "key" },
          { headerName: "Translational Name", mappedValue: "name" },
        ];
        language.value.forEach((eachLang: languageType) => {
          dataGridHeader.push({
            headerName: eachLang.language,
            mappedValue: eachLang.code.toUpperCase(),
          });
        });
        setDataGridColumns(dataGridHeader);
        language.value = language.value.map((eachLang: languageType) => {
          return {
            language: eachLang.language,
            code: eachLang.code.toUpperCase()
          }
        })
        setLanguageSupported(language.value);
      } else {
        throw new Error();
      }
    } catch (error) {
      openPopup("Error", "Something went wrong");
    }
  };

  function generateRandom() {
    var length = 8,
      charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  const uploadOnClick = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();
    const response = await translationUpload(blobData, file);
    const reportId = response.data.id;
    checkReportStatus(reportId);
  };

  const checkReportStatus = async (id: string) => {
    try {
      const response = await getReportStatus(id);
      if (response.status === 200 && response.data.features.length > 0) {
        const reportMetaData = response.data.features[0];
        const status = reportMetaData.status;
        if (status === "SUCCESS") {
          setCircularLoader(false);

          openPopup("Success", "Translation uploaded successfully");
          setFile(null);
          if (inputE1.current) {
            inputE1.current.value = "";
          }
          if (component) {
            getAllTranslationData(component);
          }
        } else if (status === "FAILURE") {
          setCircularLoader(false);
          openPopup("Error", "Something went wrong");
        } else {
          setTimeout(() => {
            checkReportStatus(id);
          }, 10000);
        }
      } else {
        throw new Error();
      }

    } catch (error) {
      setCircularLoader(false);
      openPopup("Error", "Something Went Wrong");
    }
  };

  const keyAllreadyPresent = () => {

    const translationObject = popUpData;
    const isAddingNewKey = preFilledData.name ? false : true;
    if (isAddingNewKey) {
      const sameKeyObject = copyRowData?.find((eachRow: popUpType) => {
        return eachRow.name === translationObject.name;
      });
      if (sameKeyObject) {
        return true;
      }
    }
    return false;
  };

  const changeKeyToSnakeCase = (key: string) => {

    key = key.replace(/[^\w\s]/g, '');
    key = key.trim();
    key = key.replace(/\s+/g, '_');

    key = key.toLowerCase();

    return key;
  };

  const createTranslationSet = (data: translationResponseType[]) => {
    const translationSet: { [key: string]: popUpType } = {};

    data.forEach((translation: translationResponseType) => {
      const {
        translationKey,
        translationValue,
        translationLanguage,
        translationName,
        id,
        component
      } = translation;

      translationSet[translationKey] = {
        ...translationSet[translationKey],
        [translationLanguage]: translationValue,
        name: translationName,
        component,
        idList: { ...(translationSet[translationKey]?.idList ?? {}), [translationLanguage]: id }
      };
    });

    const finalDataGridRow = Object.keys(translationSet).map(
      (eachKey: string) => {
        return { key: eachKey, ...translationSet[eachKey] };
      }
    );

    return finalDataGridRow;
  };

  const getAllTranslationData = async (translationName: string) => {
    try{
      if (languageSupported) {
        setLoader(true);
        setSeacrhedvalue("");
        const newData: translationResponseType[] = [];
        const translations = await getTranslationForEachLanguage(languageSupported, translationName);
        const translationRow = createTranslationSet(translations);
        setRowData(translationRow);
        setCopyRowData(translationRow);
        
      }
    }catch(err){
      openPopup("Error","Something went wrong");
    }finally{
      setLoader(false);
    }
  };

  async function addTranslation() {

    if (!popUpData.name) {
      setError(true);
      return;
    }

    if (keyAllreadyPresent()) {
      openPopup("Alert", "Transaltion key already present");
      return;
    }


    const translationObject = popUpData;
    const translationName = popUpData.name;
    const key = popUpData.key;
    delete translationObject.name;
    let requestBody: updateRequestType[] = [];
    const allKeys = Object.keys(translationObject);
    allKeys.forEach((eachKey: string) => {
      if (eachKey !== "key" && !preFilledData[eachKey]) {
        const translationkeyInSnakeCase = changeKeyToSnakeCase(
          translationName!
        );
        const modifiedRequestBody: updateRequestType = {
          translationKey: translationkeyInSnakeCase,
          translationName: translationName,
          translationValue: popUpData[eachKey],
          translationLanguage: eachKey,
          component: (component !== "all") ? component : (popUpData["component"] !== undefined ? `${popUpData["component"]}` : ""),
          description: "",
          ...(eachKey === "EN" && { activeStatusReason: "pending" }),
        };
        requestBody.push(modifiedRequestBody);
        delete translationObject[eachKey];
      }
    });
    if (validateTranslations(requestBody) && requestBody.length > 0) {
      await addTranslationRequest(requestBody);
    }
    await updateTranslation(translationObject);
    await getAllTranslationData(component);
    toggleModal(false);
    setError(false);
  }

  function validateTranslations(translationObjects: updateRequestType[]) {
    translationObjects.map((element: updateRequestType) => {
      if (!element.translationName) {
        return false;
      }
    });
    return true;
  }

  const addTranslationRequest = async (
    addTranslationArray: updateRequestType[]
  ) => {
    try {
      const batchData: batchType = { features: addTranslationArray };
      const response = await addTranslationRequestService(batchData);
      return response;
    } catch (error) {
      openPopup("Error", "Something went Wrong");
    }
  };

  const deleteAllTranslation = async (rowData: popUpType) => {
    try {
      const transalationIdsObj = rowData.idList;
      if (!transalationIdsObj) return;
      const promise = Object.keys(transalationIdsObj).map(async (langCode: string) => {
        const id = transalationIdsObj[langCode];
        if (id) return deleteSingleTranslation(id);
      });
      const response = await Promise.allSettled(promise);
      const rejectedResponse = response.filter((eachResponse: any) => {
        return eachResponse.status === "rejected";
      });
      if (rejectedResponse.length > 0) {
        throw new Error();
      } else {
        openPopup("Success", "Translation Updated Successfully");
      }
    } catch (error) {
      openPopup("Error", "Something went Wrong");
    }
  };

  const editParticularTransaltion = async (
    translationKey: string,
    translationLanguage: string,
    translationValue: string | Record<string, string>,
    translationName: string
  ) => {
    const url = "/v1/translations";
    const requestBody = {
      translationKey,
      translationLanguage,
      translationValue,
      translationName,
      component: (component !== "all") ? component : (popUpData["component"] !== undefined ? `${popUpData["component"]}` : ""),
    };
    const response = await ChannelkartNetworkPut(url, requestBody);
    return response;
  };

  const updateTranslation = async (translationObject: popUpType) => {
    try {
      const key = popUpData.key;
      const translationName = popUpData.name;
      const transaltionIDList = popUpData.idList;
      delete popUpData.name;
      delete popUpData.idList;
      delete popUpData.key;
      const allKeys = Object.keys(translationObject);
      const promises = allKeys.map(async (eachKey: string) => {
        if (key && popUpData[eachKey] !== preFilledData[eachKey]) {
          const response =
            popUpData[eachKey] !== ""
              ? editParticularTransaltion(
                key,
                eachKey,
                popUpData[eachKey]!,
                translationName!
              )
              : transaltionIDList && eachKey && transaltionIDList[eachKey] ?
                deleteSingleTranslation(transaltionIDList[eachKey]) : null

          return response;
        }
      });
      const response = await Promise.allSettled(promises);
      const rejectedResponse = response.filter((eachResponse: any) => {
        return eachResponse.status === "rejected";
      });
      if (rejectedResponse.length > 0) {
        throw new Error();
      } else {
        openPopup("Success", "Translation Updated Successfully");
      }
    } catch (error) {
      openPopup("Error", "Something went wrong");
    }
  };

  const columns: GridColDef[] = dataGridColumns?.map(
    (element: dataGridHeaderType) => {
      return {
        disableColumnMenu: true,
        field: element.mappedValue,
        headerName: element.headerName,
        sortable: false,
        minWidth: 110,
        flex: 1,
        headerAlign: "center",
        align: "center",
        editable: false,
        renderHeader: (params: GridColumnHeaderParams) => (
          <Tooltip title={element.headerName}>
            <b>{translate(TranslationEnum.update_translation,element.headerName)}</b>
          </Tooltip>
        ),
        valueGetter: (params: GridValueGetterParams) => {
          const field = params.field;
          if (!params.row[field]) {
            return "-";
          }
          return params.row[field];
        },
      };
    }
  );

  const addActionAttributes = (
    field: string,
    headerName: string,
    action: (params: GridRenderCellParams) => JSX.Element
  ) => {
    columns.push({
      field,
      headerName,
      sortable: false,
      minWidth: 90,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: action,
      renderHeader: (params: GridColumnHeaderParams) => (
        <Tooltip title={headerName}>
          <b>{translate(TranslationEnum.common_portal,headerName)}</b>
        </Tooltip>
      ),
    });
  };

  updateTranslationType.ActionsColumns.map((eachActions: string) => {
    switch (eachActions) {
      case "Update":
        addActionAttributes(
          "Update",
          "Update",
          (params: GridRenderCellParams) => {
            return (
              <div
                className="update-translation-update-btn"
                onClick={() => {
                  toggleModal(true);
                  setPopUpData(params.row);
                  setPreFilledData(params.row);
                }}
              >
                <FontAwesomeIcon
                  icon={faPenToSquare}
                  size="xl"
                  style={{ color: "#24c6b1" }}
                  onClick={() => { }}
                />
              </div>
            );
          }
        );
        break;
      case "Delete":
        addActionAttributes(
          "Delete",
          "Delete",
          (params: GridRenderCellParams) => {
            return (
              <div>
                <button
                  className="update-translation-delete-btn"
                  onClick={() => {
                    setConfirmationPopUp(true);
                    updateConfirmationPopData(
                      translate(TranslationEnum.common_portal, "Are you sure want to delete translation for {key}",{"key":params.row.key}),
                      async () => {
                        await deleteAllTranslation(params.row);
                        await getAllTranslationData(component);
                      }
                    );
                  }}
                >
                  {translate(TranslationEnum.common_portal,"DELETE")}
                </button>
              </div>
            );
          }
        );
        break;
    }
  });



  const debouncingTheSearch = useCallback(
    (value: string) => {
      // debouncing code
      if (timerId) {
        clearTimeout(timerId);
      }
      const newTimerId = setTimeout(() => {
        const dataAfterSearch = copyRowData?.filter((eachRow: popUpType) => {
          const keyName = eachRow.key?.toLocaleLowerCase();
          return keyName?.includes(value.toLocaleLowerCase());
        });
        setRowData(dataAfterSearch);
      }, 400); // debounce time in milliseconds
      setTimerId(newTimerId);
    },
    [searchedValue, timerId]
  );

  return (
    <>
      <div className="update-translation-container">
        <div className="update-translation-parent1">
          <div className="update-translation-upload-title-heading">
            <h1 className="update-translation-upload-title">
            {translate(TranslationEnum.update_translation,"Translation Upload")}
            </h1>
          </div>
          <div className="update-translation-upload-container">
            <div className="update-translation-upload-heading">
            {translate(TranslationEnum.update_translation,"Upload Translation Info template filled with your data")}
            </div>
            <div className="update-translation-upload-box">
              <div className="update-translation-upload-downlaod-box">
                <div className="translation-icon">
                  <RenderSvg name="DownloadImportButton" />
                  <a href="https://apptech.blob.core.windows.net/channelkart/ckuatunnati/images/file-upload/TranslationUpdateTemplate%20%281%29-KmegQYmYlUlA.xlsx">
                    <button className="translation-download-btn">
                    {translate(TranslationEnum.common_portal,"DOWNLOAD")}
                    </button>
                  </a>
                </div>
              </div>

              <div
                className="update-translation-upload-box-upload"
                onClick={() => {
                  if (!circularLoader) {
                    onUploadBtnClick();
                  }
                }}
              >
                <input
                  type="file"
                  ref={inputE1}
                  hidden
                  accept=".xls,.xlsx"
                  onChange={(event) => {
                    const fileToBeUploaded = event.currentTarget.files?.[0];
                    if (fileToBeUploaded) {
                      setFile(fileToBeUploaded);
                      const data = new FormData();
                      data.append("file", fileToBeUploaded);
                      setBlobData(data);
                    }
                  }}
                ></input>
                <div className="translation-icon">
                  <RenderSvg name="UploadImportButton" />
                  {file ? <p>{file.name}</p> : <></>}
                  <button
                    className={`translation-upload-btn ${file ? "active-button" : "nonactive-button"
                      }`}
                    onClick={(e) => {
                      if (file) {
                        setCircularLoader(true);
                        !circularLoader && uploadOnClick(e);
                      }
                    }}
                  >
                    {circularLoader ? (
                      <div>
                        <CircularProgress size={15} color="inherit" />
                        <span className="circular-progress-container ">
                        {translate(TranslationEnum.common_portal,"Upload")}
                        </span>
                      </div>
                    ) : (
                      <>{translate(TranslationEnum.common_portal,"Upload")}</>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="update-translation-keys-mgmt-heading">
          <h1 className="update-translation-keys-mgmt-title">
            {translate(TranslationEnum.update_translation,"Translation Keys Management")}
          </h1>
        </div>
        <div className="update-translation-keys-mgmt">
          <div className="update-translation-keys-mgmt-search">
            <Box width="97%">
              <Autocomplete
                disableClearable
                sx={{ width: "100%" }}
                value={component ? translate(TranslationEnum.update_translation,component)  : ""}
                onChange={(event, value: string | null) => {
                  if (value) {
                    setComponent(value);
                  }
                }}
                options={updateTranslationType.componentElements.map(option => translate(TranslationEnum.update_translation, option))}
                size="small"
                renderInput={(params) => (
                  <TextField {...params} placeholder= {translate(TranslationEnum.update_translation,"Select Label")} />
                )}
              />
            </Box>
          </div>
          <div className="translation-key-manipulators">
            <div className="translation-key-manipulators-button">
              <button
                className="translation-apply-btn"
                onClick={() => {
                  if (component) {
                    getAllTranslationData(component);
                    setResult(true);
                  }
                }}
              >
               {translate(TranslationEnum.common_portal,"APPLY")}
              </button>
              {component && component !== "all" && <button
                className="translation-add-btn"
                onClick={() => {
                  if (component) {
                    toggleModal(true);
                    setPopUpData({});
                    setPreFilledData({});
                  }
                }}
              >
                {translate(TranslationEnum.common_portal,"ADD")}
              </button>}
            </div>
            <div className="search-field">
              <input
                type="text"
                placeholder= {translate(TranslationEnum.common_portal,"Search")}
                name="search"
                className="search-input-field"
                value={searchedValue}
                onChange={(e) => {
                  setSeacrhedvalue(e.target.value);
                  debouncingTheSearch(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        {result &&
          (loader ? (
            <div>
              <Loader />
            </div>
          ) : (
            <div className="table-style">
              <DataGrid
                rows={rowData ? rowData : []}
                columns={columns}
                getRowId={(row: any) => generateRandom()}
              />
            </div>
          ))}

        <Modal
          open={openModal}
          onClose={() => {
            setError(false)
            toggleModal(false);
          }}
        >
          <Box className="translation-add-btn-modal-wrapper">
            <div className="translation-add-btn-modal-header">
              <div className="translation-edit-icon">
                <FontAwesomeIcon
                  icon={faPenToSquare}
                  size="xl"
                  style={{ color: "#ffffff" }}
                />
              </div>
              <div className="translation-add-btn-modal-title">
              {translate(TranslationEnum.update_translation,"Update translation")}
              </div>
              <button
                className="translation-modal-close-btn"
                onClick={() => {
                  setError(false)
                  toggleModal(false)
                }}
              >
                &times;
              </button>
            </div>
            <div className="translation-modal-add-new">
              <TextField
                required
                id="outlined-required"
                label= {translate(TranslationEnum.update_translation,"Translation Name")}
                placeholder="Translation Name"
                defaultValue={popUpData.name ? popUpData.name : ""}
                disabled={preFilledData["name"] ? true : false}
                onChange={(e) => {
                  setPopUpData({
                    ...popUpData,
                    name: e.target.value,
                  });
                }}
                error={error && (popUpData.name ? false : true)}
                helperText={error && (popUpData.name ? "" : "Translation Name is mandatory")}
              />
            </div>
            {languageSupported.map((eachLang: languageType) => {
              return (
                <div className="translation-modal-add-new">
                  <TextField
                    required
                    id="outlined-required"
                    label={`${translate(TranslationEnum.update_translation,"Translation value for")} ${eachLang.language}`}
                    defaultValue={
                      popUpData[eachLang.code] ? popUpData[eachLang.code] : ""
                    }
                    onChange={(e) => {
                      const code = eachLang.code;
                      setPopUpData({
                        ...popUpData,
                        [code]: e.target.value,
                      });
                    }}
                  />
                </div>
              );
            })}
            <div className="save-button">
              <button
                className="translation-add-btn-save-btn"
                onClick={async () => {
                  await addTranslation();

                }}
              >
                {translate(TranslationEnum.common_portal,"SAVE")}
              </button>
            </div>
          </Box>
        </Modal>
        <ConfirmationPopUp
          openConfirmModal={confirmationPopUp}
          message={popUpMessage}
          setOpenConfirmModal={() => {
            setConfirmationPopUp(false);
          }}
          successMethod={popUpSuccessMethod.current}
        />
      </div>
    </>
  );
};

export default UpdateTranslation;
